<div class="contact-panel">
  @if (showPopupPanel) {
    <div class="popup-panel">
      <div class="popup-panel-inlay">
        <img class="popup-logo" [alt]="altText()" [src]="mainLogoUrl()" decoding="sync" />
        <div class="addressBlock">
          <span>{{ companyName() }}</span>
          <span>{{ companyAddress().street }} {{ companyAddress().streetNumber }}</span>
          <span>{{ companyAddress().zipCode }} {{ companyAddress().city }}</span>
        </div>
        <table class="communication">
          @if (companyPhone()) {
            <tr>
              <td><span class="material-symbols-outlined" aria-hidden="true">call</span></td>
              <td><span>Telefon:</span></td>
              <td>
                <a class="contactLink" href="tel:{{ companyPhone() }}">{{ companyPhone() }}</a>
              </td>
            </tr>
          }
          @if (companyEmail()) {
            <tr>
              <td><span class="material-symbols-outlined" aria-hidden="true">mail</span></td>
              <td><span>E-Mail:</span></td>
              <td>
                <a class="contactLink" href="mailto:{{ companyEmail() }}">{{ companyEmail() }}</a>
              </td>
            </tr>
          }
          @if (companyWeb()) {
            <tr>
              <td><span class="material-symbols-outlined" aria-hidden="true">language</span></td>
              <td><span>Webseite:</span></td>
              <td>
                <a class="contactLink" href="{{ companyWeb() }}" target="_blank">{{ companyWeb() }}</a>
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
  }
  <button
    aria-label="Sie haben Fragen? Ihr Kontakt. Das Popup öffnet sich oberhalb."
    class="contact-button"
    [attr.aria-expanded]="showPopupPanel"
    aria-controls="popupPanel"
    (click)="togglePopup()"
  >
    <span class="material-symbols-outlined toggle-icon" [class.toggle-icon--open]="showPopupPanel" aria-hidden="true"
      >chevron_right</span
    >
    @if (smallLogoUrl()) {
      <img class="button-logo" [alt]="altText()" [src]="smallLogoUrl()" decoding="sync" />
    }
    <div class="text-container">
      <p>Sie haben Fragen?</p>
      <p><b>Ihr Kontakt</b></p>
    </div>
  </button>
</div>
